import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconPlaybackStopDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><rect width={24} height={24} x={0.25} y={0.365} fill="currentColor" rx={1} /></svg></>;
}
export default IconPlaybackStopDefault;